export const ROUTES = {
  ticket: '/ticket/:ticketId(\\d+)/:threadId(\\d+)?',
  new: '/new',
  root: '/'
};